
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><strong parentName="p">{`Karl Wild`}</strong>{` ist Verfasser des Ratings mit den besten Winterhotels. Er arbeitet als Publizist, Hotel- und Restauranttester in Langnau am Albis ZH. Er und sein Team, mehr als ein Dutzend Spezialisten aus Hotellerie und Tourismus sowie Vielreisende, haben alle Hotels besucht. Um die Chancengleichheit zu wahren, werden nur Hotels mit mindestens 12 Zimmern und eigenem Restaurant berücksichtigt.`}</p>
    <h3>{`Die Kriterien`}</h3>
    <ul>
      <li parentName="ul">{`Wertung der wichtigen Hotel- und Restaurantführer`}</li>
      <li parentName="ul">{`Qualitätskontrollen führender Hotelvereinigungen`}</li>
      <li parentName="ul">{`Investitionstätigkeit`}</li>
      <li parentName="ul">{`Gastfreundschaft`}</li>
      <li parentName="ul">{`Charisma und Innovationsfreude des Hoteliers`}</li>
      <li parentName="ul">{`Charakter und Originalität des Hauses`}</li>
      <li parentName="ul">{`Lage und Umgebung`}</li>
      <li parentName="ul">{`Wintersport- und Freizeitangebot`}</li>
      <li parentName="ul">{`Preis-Leistungs-Verhältnis`}</li>
      <li parentName="ul">{`Gästebewertungen`}</li>
      <li parentName="ul">{`Subjektiver Gesamteindruck`}</li>
    </ul>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;